import {Component, Input} from '@angular/core';
import { Post } from "../../../app/app.interfaces";

@Component({
  selector: 'post-author',
  templateUrl: 'post-author.html'
})

export class PostAuthor {
  @Input() post: Post;
}




// WEBPACK FOOTER //
// ./src/partials/post/post-author/post-author.ts